import { render, staticRenderFns } from "./RecurringProjectOverview.vue?vue&type=template&id=a1fb2526&"
import script from "./RecurringProjectOverview.vue?vue&type=script&lang=js&"
export * from "./RecurringProjectOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports